import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../common/hooks/useAuth";
import useRefreshToken from "../../common/hooks/useRefreshToken";
import Pricing from "../../pages/dashboard/pricing";

const PricingGate = () => {
  const { auth } = useAuth();
  const refresh = useRefreshToken();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        if (!auth?.accessToken) {
          await refresh();
        }
      } catch (err) {
        if (isMounted) setHasError(true);
      } finally {
        if (isMounted) setIsChecking(false);
      }
    };

    checkAuth();
    return () => {
      isMounted = false;
    };
  }, [auth?.accessToken, refresh]);

  if (auth?.accessToken) {
    return <Navigate to="/subscription" state={{ from: location }} replace />;
  }

  if (isChecking && !hasError) {
    return null;
  }

  return <Pricing />;
};

export default PricingGate;
